<template>
    <div class="body-panel projects">
        <div class="body-panel-control separator" v-if="info.User && info.User.MainRole === 'administrators'">
            <div class="control-block-left">
                <!--<project-select></project-select>-->
            </div>
            <div class="control-block-right">
                <div class="btns flex" v-if="info.User && info.User.MainRole === 'administrators'">
                    <svg class="svg-icon plus-square margin-top-3" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" @click.stop="onNewProject()">
                        <use xlink:href="/Content/dist/image_svg.svg#PlusSquare"></use>
                        <title>Новый проект</title>
                    </svg>
                    <svg class="svg-icon phone margin-top-3" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" @click.stop="onAppAccess()">
                        <use xlink:href="/Content/dist/image_svg.svg#Phone"></use>
                        <title>Доступ к приложению</title>
                    </svg>
                    <div class="switch margin-left-10">
                        <input type="checkbox" id="s5" checked="checked" v-model="active" @change="reload" />
                        <label class="slider-v3" for="s5"></label>
                    </div>
                </div>
            </div>
        </div>
        <div class="body-panel-content body-panel-content-page panel-block-news no-padding-right">
            <div class="body-panel-content-center">
                <div class="sortable-blocks">
                    <div :class="['panel-block', 'panel-block-new', { 'disabled': item.DateExpired } ]"
                         v-for="(item, i) of projectList"
                         v-if="item.HasAdminRights"
                         :data-id="item.Id">
                        <div class="panel-block-img-base">
                            <div class="panel-block-img">
                                <img :src="item.Image" alt="" />
                            </div>
                        </div>
                        <div class="panel-block-info">
                            <p class="panel-block-header margin-bottom-10">{{ item.Name }}</p>
                            <a class="router-link-active" href="" @click.prevent="onDomain(item.Subdomain)">{{ item.Subdomain }}</a>
                            <p class="input-text-lbl">{{ item.DatesFormatted }}</p>
                            <p class="input-text-lbl">Кол-во участинков: {{ item.UsersCount }}</p>
                        </div>
                        <div class="panel-body-actions">
                            <button class="btn btn-img" @click="$router.push('/projects/' + item.Id)" style="height:40px" title="Настройки проекта">
                                <svg class="svg-icon svg-big" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <use xlink:href="/Content/dist/image_svg.svg#Setting"></use>
                                </svg>
                            </button>
                            <button class="btn btn-img" @click="$router.push('/projects/' + item.Id + '/roles?returnUrl=/projects')" style="height:40px" title="Роли пользователей">
                                <svg class="svg-icon svg-big" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <use xlink:href="/Content/dist/image_svg.svg#Peoples"></use>
                                </svg>
                            </button>
                            <button class="btn btn-img" @click="$router.push('/projects/' + item.Id + '/users?returnUrl=/projects')" style="height:40px" title="Пользователи">
                                <svg class="svg-icon svg-big" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <use xlink:href="/Content/dist/image_svg.svg#SearchPeople"></use>
                                </svg>
                            </button>
                            <button class="btn btn-img" @click="$router.push('/projects/' + item.Id + '/trade-points?returnUrl=/projects')" style="height:40px" title="Торговые точки">
                                <svg class="svg-icon svg-big" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <use xlink:href="/Content/dist/image_svg.svg#Shop"></use>
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                <!--<Container @drop="onDrop" drag-class="opacity-ghost" drop-class="opacity-ghost-drop">-->
                    <!--<Draggable v-for="(item, i) of projectsOrdered">-->
                        <!--<div :class="['panel-block', 'panel-block-new', { 'disabled': item.DateExpired } ]">-->
                            <!--<div class="panel-block-img-base">-->
                                <!--<div class="panel-block-img">-->
                                    <!--<img :src="'/uploads/projects/' + item.Image" alt="" style="left: 50%; top: 50%; transform: translateY(-50%) translateX(-50%); height: 100%;" />-->
                                <!--</div>-->
                            <!--</div>-->
                            <!--<div class="panel-block-info">-->
                                <!--<p class="panel-block-header margin-bottom-10">{{ item.Name }}</p>-->
                                <!--<p class="panel-block-header margin-bottom-10">{{ item.Subdomain }}</p>-->
                                <!--<p class="panel-block-header margin-bottom-10">{{ item.DatesFormatted }}</p>-->
                            <!--</div>-->
                            <!--<div class="panel-body-actions">-->
                                <!--<button class="btn" @click="$router.push('/projects/' + item.Id)">Настройки</button>-->
                                <!--<button class="btn" @click="$router.push('/projects/' + item.Id + '/roles')">Роли</button>-->
                                <!--<button class="btn" @click="$router.push('/projects/' + item.Id + '/users')">Пользователи</button>-->
                                <!--<button class="btn" @click="$router.push('/projects/' + item.Id + '/trade-points')">Торговые точки</button>-->
                            <!--</div>-->
                        <!--</div>-->
                    <!--</Draggable>-->
                <!--</Container>-->
            </div>
        </div>

        <vue-headful title="Проекты" />
    </div>
</template>

<script>
    import $ from 'jquery'
    import 'datatables.net'
    import BackendApi from '../backendApi'
    import UI from '../helpers/ui-helpers'
    import moment from 'moment'
    import projectMixin from '../helpers/project-mixin'
    import claimsCheckingMixin from '../helpers/claims-checking-mixin'
    import _ from 'lodash'
    import { Container, Draggable } from "vue-smooth-dnd"
    import jqueryui from '../assets/JqueryUI/jquery-ui.min'

    let backendApi = new BackendApi();

    export default {
        name: "projects",

        components: { Container, Draggable },

        data() {
            return {
                projectList: [],
                loading: false,
                canBeLoaded: true,
                page: 1,
                active: true,
                scrollTop: null,
                firstLoad: true,
            }
        },

        // computed: {
        //     projectsOrdered: function () {
        //         return _.orderBy(this.projectList, 'ProjectOrder');
        //     }
        // },

        mixins: [projectMixin, claimsCheckingMixin],

        methods: {
            onDomain(domain) {
                if(domain && domain !== '-') {
                    window.open('https://' + domain);
                }
            },

            onChangeDate(item, formatted, raw) {
                item[raw] = moment(item[formatted], 'DD.MM.YYYY').format();
            },

            onNewProject(){
                this.$router.push('/projects/0')
            },

            reload() {
                let vm = this;

                vm.page = 1;
                vm.projectList = [];
                vm.canBeLoaded = true;
                vm.loading = false;
                vm.firstLoad = true;
                vm.loadNext();
            },

            loadNext(){
                let vm = this;
                this.loading = true;
                UI.blockUI('.projects', 'Загрузка...');
                this.callApiWrapper(backendApi.projectList((vm.page - 1) * 20, 20, vm.active)).then(function (resp) {
                    if(resp.hasError){
                        UI.toastr.error('Ошибка во время загрузки проектов');
                    }
                    else{
                        if(resp.data && resp.data.length) {
                            for(let item of resp.data){
                                if(item.StartDate){
                                    item.DatesFormatted = 'с ' + vm.formatDate(item.StartDate);
                                }
                                if(item.EndDate){
                                    item.DatesFormatted += (item.StartDate ? ' по ' : '') + vm.formatDate(item.EndDate);
                                }
                            }
                            vm.projectList.push(...resp.data);
                        }
                        else{
                            vm.canBeLoaded = false;
                        }
                    }
                    UI.unblockUI('.projects');
                    vm.loading = false;
                });
            },

            onRowClick(item){
                this.$router.push('/projects/' + item.Id);
            },

            onDrop(dropResult){
                let vm = this;

                if(dropResult.removedIndex === dropResult.addedIndex){
                    return;
                }

                let projectsTemp = _.orderBy(vm.projectList, 'ProjectOrder');
                let itemToAdd;
                if (dropResult.removedIndex != null) {
                    itemToAdd = projectsTemp.splice(dropResult.removedIndex, 1)[0];
                }
                if (dropResult.addedIndex !== null) {
                    projectsTemp.splice(dropResult.addedIndex, 0, itemToAdd)
                }

                let order = 1;
                projectsTemp.forEach((role) => {
                    role.ProjectOrder = order++;
                });

                vm.projectList = projectsTemp;

                this.saveProjectsOrder();
            },

            saveProjectsOrder(){
                let saveObj = this.projectList.map(x => {
                   return {
                       Id: x.Id,
                       ProjectOrder: x.ProjectOrder}
                });
                backendApi.projectOrderSave(saveObj).then(function (response) {
                    if (response.hasError) {
                        UI.toastr.error('Ошибка при сохранении проектов');
                    }
                });
            },

            onAppAccess() {
                this.$router.push('/projects/appaccess');
            }
        },

        mounted () {
            let vm = this;

            vm.loadNext();

            vm.$nextTick(() => {

                $('.body-panel-content').on('scroll', function () {
                    if (!vm.loading && vm.canBeLoaded) {
                        let elem = $(this);
                        let scrollTop = elem.scrollTop();
                        vm.scrollTop = scrollTop;
                        if(elem[0].scrollHeight - scrollTop - 200 <= elem.outerHeight()) {
                            vm.page++;
                            vm.loadNext();
                        }
                    }
                });

                $('.sortable-blocks').sortable({
                    revert: 100,
                    stop: function() {
                        let order = 1;
                        $('.sortable-blocks > .panel-block').each(function (index, item) {
                            console.info()
                            let projectId = parseInt($(item).data('id'));
                            let projectIndex = vm.projectList.findIndex(x => x.Id === projectId);
                            console.info('[projectIndex, projectId, order]', [projectIndex, projectId, order])
                            let p = vm.projectList[projectIndex];
                            p.ProjectOrder = order;
                            vm.$set(vm.projectList, projectIndex, p);

                            order++;
                        });
                        vm.saveProjectsOrder();
                    }
                });

            })
        },

        destroyed(){
            $('.body-panel-content').off('scroll');
        }
    }
</script>

<style scoped>
    .sortable-blocks {
        padding: 14px;
    }
    .sortable-blocks > div {
        margin: 0 10px 10px 0;
        float: left;
    }
    .ui-sortable-placeholder{
        float: left;
    }
</style>



// WEBPACK FOOTER //
// Content/src/views/Projects.vue